import { ApiBase } from "./api-base";

export class HttpNaverAiApi extends ApiBase {
  onApiName(): string {
    return "NaverAiApi";
  }

  onUrlPath(): string {
    return "";
  }

  public async postStream(param: any) {
    const response = await this.requestStream(param);
    console.log("response : ", response);
    return response;
  }
}
